import type { ReactNode } from "react";
import { PageHeader } from "@/components/data-display/page-header";
import { WipHint } from "@/components/ui/wip-hint";
import { PAY_COPY } from "./copy";

/**
 * The page chrome: document-level referrer policy, the title every state of
 * this route keeps, and the footer.
 *
 * The `<meta name="referrer">` is here rather than in `index.html` on purpose —
 * it belongs to *this route*, not the app. A payer who reaches `/pay` from a
 * link in an email, a chat or a PDF must not send the invoking URL onward, and
 * the token is in that URL. React hoists this tag into `<head>`.
 */
export function CheckoutFrame({
  subtitle = PAY_COPY.pageSubtitle,
  centered = false,
  children,
}: {
  subtitle?: string;
  /** Vertically centre a lone state (not-active, error) in the viewport. */
  centered?: boolean;
  children: ReactNode;
}) {
  return (
    <main className="mx-auto flex min-h-screen w-full max-w-[720px] flex-col px-4 py-10 sm:px-6">
      <meta name="referrer" content="no-referrer" />

      <PageHeader title={PAY_COPY.pageTitle} subtitle={subtitle} actions={<WipHint />} />

      <div className={centered ? "flex flex-1 flex-col justify-center" : "flex flex-col gap-5"}>{children}</div>

      <footer className="mt-8 border-t border-line pt-4 text-xs text-muted">
        <p>{PAY_COPY.footerNoThirdParty}</p>
        <p className="mt-1">{PAY_COPY.environmentNote}</p>
      </footer>
    </main>
  );
}
